import { useSnackbar } from 'notistack'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { SupplyChainContext } from 'features/globalSetup/contexts/SupplyChainContext'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { Schema } from '../../form/schema'
import { toDTO } from './api/mapper'
import { UPDATE_DOMAIN_SUPPLY_CHAINS } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateDomainSupplyChains, UseUpdateDomainSupplyChainsProps } from './types'

export const useUpdateDomainSupplyChains = ({
  supplyChainName,
}: UseUpdateDomainSupplyChainsProps): UseUpdateDomainSupplyChains => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'supplyChain.domainSids.update',
  })
  const { enqueueSnackbar } = useSnackbar()
  const { setLoading } = useContext(SupplyChainContext)

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_DOMAIN_SUPPLY_CHAINS,
    onCompleted: async (data: Data): Promise<void> => {
      const {
        bulkUpdateDomainSupplyChains: { errors },
      } = data

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error', { supplyChain: supplyChainName }), { variant: 'error' })
      } else {
        enqueueSnackbar(t('success', { supplyChain: supplyChainName }), { variant: 'success' })
      }
    },
  })

  useEffect(() => {
    setLoading(isPending)
  }, [isPending])

  const update = (data: Schema): void => {
    mutateAsync({ input: toDTO(data) })
  }

  return {
    update,
  }
}
